
export const appRoles = {
    admin:"Amministratore",
    user:"Utente"
}